import type { EvaluationContext } from '@openfeature/react-sdk';

interface VoterEvaluationContextParams {
  voterId: string | undefined;
  isFreeOwner: boolean | null | undefined;
  isSurvey: boolean | undefined;
  voteKey: string;
}

export interface VoterEvaluationContext {
  voter_id: string;
  is_free_owner: boolean | string;
  is_survey: boolean | undefined;
  vote_key: string;
}

export function getVoterEvaluationContext({
  voterId,
  isFreeOwner,
  isSurvey,
  voteKey,
}: VoterEvaluationContextParams): VoterEvaluationContext & EvaluationContext {
  return {
    voter_id: voterId || '',
    is_free_owner: getValueOrFallback(isFreeOwner, undefined),
    is_survey: getValueOrFallback(isSurvey, undefined),
    vote_key: voteKey,
  };
}

const getValueOrFallback = (value: unknown, fallbackValue: any) => {
  if (value !== null && value !== undefined) return value;

  return fallbackValue;
};
